import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/Group 51.svg";
import "./navbar.scss";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const handleNav =()=>{
    setOpen(false)
    setTimeout(()=>{
      window.scrollTo({top:0,behavior:'smooth'})
    },200)
  }

  return (
    <div className="navbar-area">
      <div className="container-fluid d-flex flex-row justify-content-between align-items-center px-4">
        <div className="navbar-brand" style={{ flex: "1 1 2%" }}>
          <NavLink to="/">
            <img className="navbar-brand-img" alt="Logo" />
          </NavLink>
        </div>

        <ul className="navItems d-flex list-unstyled mb-0">
          <li>
            <NavLink className="links" to="/" aria-current="page" onClick={()=>handleNav()}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink className="links" to="/about" onClick={()=>handleNav()}>
              About us
            </NavLink>
          </li>
          <li>
            <NavLink className="links" to="/ourTeam" onClick={()=>handleNav()}>
              Team
            </NavLink>
          </li>
          <li>
            <NavLink className="active" to="/" aria-current="page" onClick={()=>handleNav()}>
              Expertise
            </NavLink>
          </li>
        </ul>

        <div className="nav-toggler-icon" onClick={() => setOpen(true)}>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            className="hamIcon"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z"></path>
          </svg>
        </div>

        {/* {open && ( */}
        <div
          id="customSidebar"
          className={`custom-sidebar ${open ? "show" : ""}`}
        >
          <div className="close-btn-wrapper" onClick={() => handleNav()}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 1024 1024"
              fillRule="evenodd"
              className="close-icon"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"></path>
            </svg>
          </div>

          <ul className="sidebar-list list-unstyled">
            <li>
              <NavLink
                className="active"
                to="/"
                onClick={() => handleNav()}
                aria-current="page"
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={() => handleNav()}>
                About us
              </NavLink>
            </li>
            <li>
              <NavLink to="/ourTeam" onClick={() => handleNav()}>
                Team
              </NavLink>
            </li>
            <li>
              <NavLink
                className="active"
                to="/"
                onClick={() => handleNav()}
                aria-current="page"
              >
                Expertise
              </NavLink>
            </li>
          </ul>
        </div>
        {/* )} */}
      </div>
    </div>

    // <div className="navbar-area">
    //   <div className="container-fluid d-flex flex-row justify-content-between align-items-center px-4">
    //     <div className="flex-grow-1">
    //       <Link>
    //         <img src={Logo} alt="Logo" />
    //       </Link>
    //     </div>
    //     <NavLink className="navItems">
    //       <li>
    //         <Link to="/">Home</Link>
    //       </li>
    //       <li>
    //         <Link to="any">Any</Link>
    //       </li>
    //       <li>
    //         <Link to="ff">ff</Link>
    //       </li>
    //       <li>
    //         <Link>Home</Link>
    //       </li>
    //     </NavLink>
    //   </div>
    // </div>
  );
};

export default Navbar;
